<template>
  <div class="invite-placement-test" style="padding:16px;">
    <Loading v-if="loading" />
    <div
      class="placementTestRow"
      v-for="({ id, name, level, number_of_questions },
      index) in placementTests.results"
      :key="id"
    >
      <div>{{ name }} - {{ level }} ({{ number_of_questions }})</div>
      <button class="btn" @click="openInviteList(index)">
        {{ $t("invite") }}
      </button>
    </div>
    <van-action-sheet
      v-model="inviteActionSheet"
      :title="actionSheetName"
      :round="false"
      :cancel-text="$t('cancel')"
    >
      <van-field
        v-model="invite"
        center
        clearable
        :label="$t('emails')"
        :placeholder="$t('enter email')"
      >
        <template #button>
          <div class="addInvite-btn btn add-btn" @click="addInvite">
            {{ $t("add") }}
          </div>
        </template>
      </van-field>
      <div class="invite-emails" v-if="Object.entries(invites).length > 0">
        <div
          class="email-tags"
          v-for="([email, status], invIndex) in Object.entries(invites)"
          :key="`email-${invIndex}`"
        >
          <div class="invite-list-wrapper">
            <div class="invite-list-item" v-if="!status.done">
              {{ email }}
              <!-- <span class="invite-list-item" v-if="!status.done"> -->
              <!-- <span class="invite-list-item">
                (<van-icon name="warning" color="red" />
                {{ $t("Test not taken") }})
              </span> -->
            </div>
            <div class="invite-list-item">
              <!-- <span class="invite-list-item" v-if="status.done">
                <van-icon name="checked" color="green" />
                {{ $t("Test taken") }}
              </span> -->
              <div
                class="addInvite-btn btn uninvite-btn"
                v-if="!status.done"
                @click="deleteInvite(email)"
              >
                {{ $t("uninvite") }}
              </div>
              <div
                class="addInvite-btn btn reminder-btn"
                v-if="!status.done"
                @click="
                  sendReminder({
                    pk: placementTests.results[currentplacementTestIndex].id,
                    emails: [email]
                  })
                "
              >
                {{ $t("Send Reminder") }}
              </div>
              <!-- <div
                class="addInvite-btn btn"
                v-if="!status.done"
                @click="deleteInvite(email)"
              >
                {{ $t("reinvite") }}
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <button style="margin-left:16px;" class="btn" @click="sendInvitations">
        {{ $t("send") }}
      </button> -->
    </van-action-sheet>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import emailValidation from "@/helpers/emailValidation";
import Loading from "@/components/Loading";

export default {
  name: "InvitePlacementTest",
  components: { Loading },
  computed: {
    ...mapState("placementTest", ["placementTests", "loading"]),
    actionSheetName() {
      return this.currentplacementTestIndex > 0
        ? `${this.$t("invite")} - ${
            this.placementTests.results[this.currentplacementTestIndex].name
          }`
        : "";
    }
  },
  data() {
    return {
      inviteActionSheet: false,
      currentplacementTestIndex: null,
      invites: [],
      invite: ""
    };
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("placementTest", [
      "getPlacementTests",
      "sendInvites",
      "sendUninvites",
      "sendReminder"
    ]),
    openInviteList(index) {
      this.inviteActionSheet = true;
      this.invites = this.placementTests.results[index].invite_list_with_results
        ? JSON.parse(
            this.placementTests.results[index].invite_list_with_results
          )
        : {};
      this.currentplacementTestIndex = index;
    },
    sendInvitations() {
      const emails = Object.keys(this.invites).map(email => email);
      this.sendInvites({
        pk: this.placementTests.results[this.currentplacementTestIndex].id,
        emails
      }).then(() => {
        // refresh data from vuex store values
        this.openInviteList();
      });
    },
    deleteInvite(email) {
      let invites = JSON.parse(JSON.stringify(this.invites));
      delete invites[email];
      this.invites = invites;
      this.sendUninvites({
        pk: this.placementTests.results[this.currentplacementTestIndex].id,
        emails: [email]
      });
    },
    addInvite() {
      this.addInviteToList(this.invite.split(","));
    },
    addInviteToList(emails) {
      this.invites = emails.reduce((accu, email) => {
        email = email.trim().toLowerCase();
        if (emailValidation(email) && !(email in accu)) {
          accu[email] = { done: false };
        } else if (!emailValidation(email)) {
          this.$notify({
            type: "error",
            group: "alert",
            title: this.$t(`Please check the email entered`),
            text: `${email}`
          });
        }
        return accu;
      }, this.invites);
      this.invite = "";
      this.sendInvitations();
    }
  },
  mounted() {
    this.SET_PAGE_TITLE("Placement Test");
    this.getPlacementTests();
  }
};
</script>

<style lang="scss">
.invite-placement-test {
  .invite-list-wrapper {
    display: flex;
    justify-content: space-between;
    .invite-list-item {
      display: flex;
      align-items: center;
    }
  }
  .uninvite-btn {
    background: #de4b4b;
  }
  .reminder-btn {
    background: #53b353;
  }
  .add-btn {
    background: #53b353;
  }
  .placementTestRow {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
    padding: 20px;
    align-items: center;
  }
  .invite-emails {
    margin: 16px;
    max-height: 150px;
    overflow: auto;
  }
  .email-tags {
    margin: 5px;
    // width: 100%;
  }
}
</style>
